import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = ['form', 'field', 'input', 'successNotice'];

	connect() {
		// Call connect from FormController
		super.connect();
	}

	/**
	 * Submit newsletter form.
	 *
	 * @param {Event} e
	 */
	submit(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		this.formTarget.setAttribute('data-group-loading', 'true');
		this.redirectUrl = '';

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.formTarget.classList.add('hidden');
					this.successNoticeTarget.classList.remove('hidden');

					if(response.data.url) {
						this.redirectUrl = response.data.url;
					}
				}
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-loading');
			});

		// Redirect if laposta url is set
		setTimeout(() => {
			if(this.redirectUrl != '') {
				window.open(this.redirectUrl, '_blank').focus();
			}
		}, 3000)
		
	}

}
